import { useState } from 'react';
import { AgCharts } from 'ag-charts-react';
import { EventsByTypeChartLogic } from './EventsByTypeChart';
import './EventsByTypeChart.scss';
import {
    ClientSideRowModelModule,
    ModuleRegistry,
} from 'ag-grid-enterprise';
import { Modal, Button, Spin } from 'antd';
import { ExpandAltOutlined } from '@ant-design/icons';
import LoadingOrbitalSpinner from '../LoadingOrbitalSpinner/LoadingOrbitalSpinner';

ModuleRegistry.registerModules([ClientSideRowModelModule]);

function EventsByTypeChart({ startAndEndUnixDatesParams = '', formatDateRange = '' }) {
    const { EventsByTypeConfig, loading } = EventsByTypeChartLogic(startAndEndUnixDatesParams, formatDateRange);
    const [modalOpen, setModalOpen] = useState(false);

    return (
      <Spin spinning={loading} indicator={<LoadingOrbitalSpinner />}>
        <div className='events-by-type-chart-wrapper' style={{ flex: '1', minWidth: '300px' }}>
            <div className='events-by-type-chart'>
                <Button
                    className='events-by-type-chart-expand-btn'
                    type='text'
                    size='small'
                    icon={<ExpandAltOutlined />}
                    onClick={() => setModalOpen(true)}
                />
                {EventsByTypeConfig && <AgCharts
                    options={EventsByTypeConfig}
                />}
            </div>
            <Modal
                centered
                open={modalOpen}
                onCancel={() => setModalOpen(false)}
                footer={null}
                width='90%'
            >
                {EventsByTypeConfig && <AgCharts options={EventsByTypeConfig} style={{ height: '70vh' }} />}
            </Modal>
        </div>
    </Spin>
    )
}

export default EventsByTypeChart
